import API from "../API";
import {
  getGuestToken,
  getGuestTokenParams,
  getToken,
  withGuestTokenPayload,
} from "../../token/token";

export const AddToCartApi = async (payload) => {
  try {
    const response = await API.post(
      `/ecommerce/cart`,
      withGuestTokenPayload(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const UpdateCartItemApi = async (payload) => {
  try {
    const response = await API.put(
      `/ecommerce/cart/${payload?.cartItemId || ""}`,
      withGuestTokenPayload(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const RemoveCartItemApi = async (payload) => {
  try {
    const response = await API.delete(
      `/ecommerce/cart/${payload?.cartItemId || ""}`,
      { params: getGuestTokenParams() },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const ClearCartApi = async () => {
  try {
    const response = await API.delete(`/ecommerce/clear/cart`, {
      params: getGuestTokenParams(),
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetAllCartItemApi = async (payload) => {
  try {
    const token = getToken("token");
    const guestToken = !token ? getGuestToken() : null;

    if (!token && !guestToken) {
      return { data: { response: { items: [] } } };
    }

    const response = await API.get(`/ecommerce/cart`, {
      params: guestToken ? { guestToken } : getGuestTokenParams(),
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetDeliveryChargeApi = async (payload) => {
  try {
    const response = await API.get(
      `/ecommerce/delivery/charge?cod=${payload?.cod || 0}`,
      { params: getGuestTokenParams() },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const magicFileUrlApi = async (payload) => {
  try {
    const response = await API.get(
      `/ecommerce/v1/presigned-url?fileName=${payload?.fileName || ""}&contentType=${payload?.contentType || ""}&fileType=${payload?.fileType || ""}&userId=${payload?.userId || ""}&isAndroid=${false}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const fileUploadCompleteApi = async (payload) => {
  try {
    const response = await API.post(`/ecommerce/api/files/complete`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const ContactUsApi = async (payload) => {
  try {
    const response = await API.post(`/common/contact-us`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};
